import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Btn, SectionHead } from "@/components/kit";
import { Reveal } from "@/lib/anim";
import { COUNTRY_LINKS, COUNTRIES } from "@/lib/content";
import { COUNTRY_IMG } from "@/lib/images";

export default function Sourcing() {
  return (
    <>
      <Seo title="Product Sourcing Australia — Countries & Factories" canonical="/sourcing" description="Product and fashion sourcing for Australian brands: first-hand notes on supplier and factory sourcing from India, China, Bangladesh, Vietnam, Turkey and the UAE." keywords="product sourcing Australia, fashion sourcing Australia, factory sourcing, clothing manufacturers, apparel manufacturers, sourcing beyond China, supplier and factory sourcing, sourcing consultant Australia" />
      <PageHero
        eyebrow="Sourcing"
        crumbs={[{ label: "Home", to: "/" }, { label: "Sourcing" }]}
        title="Six countries, ordered from first-hand."
        lead="India, China, Bangladesh, Vietnam, Turkey and the UAE. These are not markets Prox has read about. They are markets Prox has placed orders in, argued about price in, and had shipments arrive from."
        actions={[<Btn key="1" to="/services/supplier-and-factory-sourcing" variant="clay">Start a supplier search, $3,900</Btn>]}
      />
      <Section bg="bone">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {COUNTRY_LINKS.map((c, i) => {
            const d = COUNTRIES[c.slug];
            return (
              <Reveal i={i % 3} key={c.slug}>
                <Link to={`/sourcing/${c.slug}`} className="card block h-full overflow-hidden" data-testid={`country-card-${c.slug}`}>
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={COUNTRY_IMG[c.slug]} alt="" className="img-cover duo" loading="lazy" />
                  </div>
                  <div className="p-7">
                    <h2 className="t-h3">{c.name}</h2>
                    <p className="t-sm text-[var(--muted)] mt-3">{d.body}</p>
                    <span className="lnk mt-6 inline-flex">Read the notes<span className="arrow-anim">→</span></span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
        <p className="t-sm text-[var(--muted)] mt-10 measure">The UAE is used for sampling, trims and fast reorders rather than volume production. Ask about it on a call. Ranges shown on each country page reflect what Prox has negotiated for small and mid-sized orders; they are indicative, not quotes.</p>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-3xl">
          <h2 className="t-display2">Need a shortlist, not a lecture?</h2>
          <p className="t-lead mt-6 text-[var(--stone)]">A Supplier Search builds five qualified factories with quotes against your specification. AUD $3,900 inc GST.</p>
          <Btn to="/services/supplier-and-factory-sourcing" variant="clay" className="mt-9">See Supplier Search</Btn>
        </div>
      </Section>
    </>
  );
}
